const state = {
  selected: {},
  productFamilies: [],
};

export { state };
